import { withStyles } from '@material-ui/core/styles';
import { isMobile } from 'react-device-detect';

const styles = theme => ({
  textPolicy: {
    fontSize: '12px',
    fontFamily: 'Sura Sans',
    color: '#0033A0'
  },
  textSelecteds: {
    fontSize: '12px',
    fontFamily: 'Sura Sans',
    color: '#000000'
  },
  textFooter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#FFF',
    fontSize: '16px',
    width: '68px',
    height: '36px',
    borderRadius: '5px',
    fontWeight: 600,
    fontFamily: 'Sura Sans'
  },
  textFooters: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#FFF',
    fontSize: '15px',
    minWidth: '75px',
    height: '36px',
    borderRadius: '5px',
    fontWeight: 600,
    fontFamily: 'Sura Sans'
  },
  pagination: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px 0'
  },
  paginationControls: {
    display: 'flex',
    alignItems: 'center'
  },
  paginationCircles: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    listStyleType: 'none',
    padding: 0,
    margin: isMobile ? '0' : '0 10px'
  },
  circle: {
    width: 30,
    height: 30,
    margin: '0 5px',
    borderRadius: '50%',
    border: '1px solid #ccc',
    display: 'flex',
    justifyContent: 'center',
    fontFamily: 'Sura Sans',
    alignItems: 'center',
    cursor: 'pointer',
    color: '#000',
    '&.active': {
      backgroundColor: '#2d6df6',
      color: '#fff',
      borderColor: '#2d6df6'
    }
  },
  paginationArrow: {
    padding: isMobile ? '6px' : '12px'
  },
  textCenter: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'Sura Sans',
  },
  tablePagination: {
    '& .MuiTablePagination-toolbar': {
      paddingLeft: 0,
      paddingRight: 0
    },
    '& .MuiTablePagination-spacer': {
      display: 'none'
    },
    '& .MuiTablePagination-caption': {
      display: 'none'
    },
    '& .MuiTablePagination-actions': {
      display: 'none'
    }
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/containers/agent/Tabs/Payments/paginationBar/PaginationBarStyles.js